import { render, staticRenderFns } from "./TitleOnly.vue?vue&type=template&id=fc9ef7b2&scoped=true&"
import script from "./TitleOnly.vue?vue&type=script&lang=js&"
export * from "./TitleOnly.vue?vue&type=script&lang=js&"
import style0 from "./TitleOnly.vue?vue&type=style&index=0&id=fc9ef7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9ef7b2",
  null
  
)

export default component.exports